import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_3 = ["data-bs-target", "id", "onClick", "aria-controls", "aria-selected"]
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "general",
  role: "tabpanel",
  "aria-labelledby": "tab-general",
  tabindex: "0"
}
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "documents",
  role: "tabpanel",
  "aria-labelledby": "tab-documents",
  tabindex: "0"
}
const _hoisted_7 = {
  class: "tab-pane fade",
  id: "incidents",
  role: "tabpanel",
  "aria-labelledby": "tab-incidents",
  tabindex: "0"
}
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "comments",
  role: "tabpanel",
  "aria-labelledby": "tab-comments",
  tabindex: "0"
}
const _hoisted_9 = {
  key: 1,
  class: "container-fluid"
}

import {ref} from "vue";
import {Audit} from "@/audit.types";
import {SystemAlerts, ConfirmModal} from "./Misc";
import AuditDetailsDocuments from "./AuditDetails/AuditDetailsDocuments.vue";
import AuditDetailsIncidents from "./AuditDetails/AuditDetailsIncidents.vue";
import AuditDetailsComments from "./AuditDetails/AuditDetailsComments.vue";
import AuditDetailsGeneral from "./AuditDetails/AuditDetailsGeneral.vue";

import {useAuditStore} from "@/stores/auditStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetails',
  props: {
    id: Number,
    runAudits: Boolean,
    createAudits: Boolean,
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;
const selectedTab = ref("general");
const tabs = [
    {name: "General", id: "general"},
    {name: "Documents", id: "documents"},
    {name: "Incidents", id: "incidents"},
    {name: "Comments", id: "comments"},
];
const auditStore = useAuditStore();

const audit = ref<Audit>({} as Audit);

const getData = async function () {
    audit.value = await auditStore.getById(props.id!);
};
;(
  ([__temp,__restore] = _withAsyncContext(() => getData())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(SystemAlerts)),
    (audit.value != undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
              return _createElementVNode("li", {
                class: "nav-item",
                role: "presentation",
                key: tab.id
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", {active: tab.id == selectedTab.value}]),
                  "data-bs-toggle": "tab",
                  "data-bs-target": `#${tab.id}`,
                  type: "button",
                  role: "tab",
                  id: `tab-${tab.id}`,
                  onClick: _withModifiers(($event: any) => (selectedTab.value = tab.id), ["prevent"]),
                  "aria-controls": tab.id,
                  "aria-selected": tab.id === selectedTab.value
                }, _toDisplayString(tab.name), 11, _hoisted_3)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(AuditDetailsGeneral, {
                "run-audits": __props.runAudits,
                onReload: getData,
                "create-audits": __props.createAudits,
                audit: audit.value,
                id: __props.id
              }, null, 8, ["run-audits", "create-audits", "audit", "id"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AuditDetailsDocuments, {
                "run-audits": __props.runAudits,
                "create-audits": __props.createAudits,
                audit: audit.value,
                id: __props.id
              }, null, 8, ["run-audits", "create-audits", "audit", "id"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(AuditDetailsIncidents, {
                "run-audits": __props.runAudits,
                "create-audits": __props.createAudits,
                audit: audit.value,
                id: __props.id
              }, null, 8, ["run-audits", "create-audits", "audit", "id"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(AuditDetailsComments, {
                "run-audits": __props.runAudits,
                "create-audits": __props.createAudits,
                audit: audit.value,
                id: __props.id
              }, null, 8, ["run-audits", "create-audits", "audit", "id"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "header w-100 text-center" }, [
            _createElementVNode("h3", { class: "mx-auto" }, "Loading...")
          ], -1)
        ]))])),
    _createVNode(_unref(ConfirmModal))
  ], 64))
}
}

})